import {STATE_PROP_NAME} from './company-report-constants'

export const getState = state => state[STATE_PROP_NAME]
export const getCompanyId = state => getState(state).companyId
export const getTimeFrameDays = state => getState(state).timeFrameDays
export const getGeography = state => getState(state).selectedGeography
